module.exports = __webpack_public_path__ + "img/L_319_0.1e261cf8.png";